import { XCentiumFlyoutDrawerActions } from "@electricMotorShop/Store/Components/FlyoutDrawer/FlyoutDrawerReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<XCentiumFlyoutDrawerActions>;

type HandlerType = Handler<
    {
        drawer: "MiniCart" | "LocationLink";
        isOpen: boolean;
    },
    Props
>;

export const DispatchSetIsOpen: HandlerType = ({ dispatch, parameter: { drawer, isOpen } }) => {
    switch (drawer) {
        case "MiniCart":
            dispatch({
                type: "Custom/FlyoutDrawer/SetMiniCartFlyoutDrawerIsOpen",
                isOpen,
            });
            break;
        case "LocationLink":
            dispatch({
                type: "Custom/FlyoutDrawer/SetLocationLinkFlyoutDrawerIsOpen",
                isOpen,
            });
            break;
        default:
            break;
    }
};

export const chain = [DispatchSetIsOpen];

const setDrawerIsOpen = createHandlerChainRunner(chain, "SetDrawerIsOpen");
export default setDrawerIsOpen;